import { Box, Icon, Text } from '@fairfashion/design-system'
import { useLocation } from 'react-router-dom'

import * as Styles from './sidebar-item.styles'
import { SidebarItemProps } from './sidebar-item.types'

export const SidebarItem = ({
  icon,
  title,
  url,
  onClick,
  pending,
  customText,
}: SidebarItemProps) => {
  const pathname = useLocation().pathname

  return (
    <Styles.SidebarItemWrapper
      borderRadius="12px"
      padding={2}
      active={pathname === url}
      onClick={onClick}
      width="100%"
      alignItems="center"
      gap={2}
    >
      {customText
        ? customText
        : icon &&
          title && (
            <Box gap={1} alignItems="center">
              <Icon name={icon} color="white" size={24} />
              <Text variant="p" size="normal" color="white">
                {title}
              </Text>
            </Box>
          )}
      {pending && (
        <Box alignItems="center">
          <Styles.SidebarItemPendingDot />
        </Box>
      )}
    </Styles.SidebarItemWrapper>
  )
}
